export default __webpack_public_path__ + "static/media/html.02456ca8.svg";